import * as React from 'react';
import classNames from 'classnames';
import BaseHeading from '../../common/BaseHeading/BaseHeading.esm.js';
import BaseSectionWithAnalyticsContext from '../../common/BaseSection/BaseSectionWithAnalyticsContext.esm.js';
import { Grid } from '../../common/Grid/Grid.esm.js';
import { BaseNucleobaseComponent } from '@invitae/nucleobase-core';
import styles from './ListWithIconBulletsSection.module.esm.js';

var ListWithIconBulletsSection = function (_a) {
    var _b = _a.fields, heading = _b.heading, headingAlignment = _b.headingAlignment, items = _b.items, internalName = _b.internalName, decorativeShape = _b.decorativeShape, footer = _b.footer, id = _a.id, dataCy = _a["data-cy"];
    return (React.createElement(BaseSectionWithAnalyticsContext, { className: styles.listSection, "data-cy": dataCy, id: id, sectionName: internalName },
        decorativeShape && React.createElement(BaseNucleobaseComponent, { source: decorativeShape }),
        heading && (React.createElement(BaseHeading, { heading: heading, headingAlignment: headingAlignment, headingClasses: styles.listSectionHeader })),
        React.createElement(Grid, { className: classNames(styles.grid, styles.gridMarginTop) }, items.map(function (item, key) { return (React.createElement(BaseNucleobaseComponent, { classes: { root: styles.gridItem2 }, key: key, source: item })); })),
        footer && React.createElement(BaseNucleobaseComponent, { source: footer })));
};

export { ListWithIconBulletsSection as default };
//# sourceMappingURL=ListWithIconBulletsSection.esm.js.map
